import React, { useEffect, useState } from 'react';
import BoxContainer from '../BoxContainer/BoxContainer';
import { get, split } from 'lodash';
import { useForm, Controller } from 'react-hook-form';
import { useUpdateClient } from '../../utils/service/service_user_api';
import { withRouter } from 'react-router-dom';
import { useClientByPhone } from '../../utils/service/service_user_api';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import {
  PaymintsButton,
  BUTTON_TYPE,
} from 'paymints-address-autocomplete-field';
import ErrorMessageInput from '../ErrorMessajeInput/ErrorMessageInput';
import { states } from '../../utils/constants';
import { validSSN, validAge } from '../../utils/validations';
import SpinnerLoader from '../SpinnerLoader/SpinnerLoader';
import { getClientStore, getISODateString } from '../../utils/util';
import { useSensitiveData } from '../../contexts/sensitiveDataContext';
import { encrypt, decrypt } from '../../utils/encryption';
import './account.css';
import { saveSensitiveData } from '../../utils/service/service_api';
import { useAllTenants } from '../../utils/service/service_tenant_api';
import css from '../../styles/modules/Account/account.module.css';
import useWindowWidth from '../../hooks/nonGQLhooks/useWindowWidth';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import displayPageHeader from '../../utils/displayPageHeadline';
import { useDispatch, useSelector } from 'react-redux';
import { closeNavbar } from '../../reducers/navbar/navbarActions';
import { setLoading } from '../../reducers/utility/utilityActions';

const FieldsPersonalInformation = ({
  register,
  watch,
  setValue,
  control,
  errors,
  client,
  branding,
}) => {
  const nav = document.querySelector('.menu-nav-bar__grey-bar');
  const [border1, setBorder1] = useState(`1px solid ${branding?.accentColor}`);
  const [border2, setBorder2] = useState(`1px solid ${branding?.accentColor}`);
  const [border3, setBorder3] = useState(`1px solid ${branding?.accentColor}`);
  const [border4, setBorder4] = useState(`1px solid ${branding?.accentColor}`);
  const [border5, setBorder5] = useState(`1px solid ${branding?.accentColor}`);
  const [border6, setBorder6] = useState(`1px solid ${branding?.accentColor}`);
  const [border7, setBorder7] = useState(`1px solid ${branding?.accentColor}`);
  const [border8, setBorder8] = useState(`1px solid ${branding?.accentColor}`);
  const [border9, setBorder9] = useState(`1px solid ${branding?.accentColor}`);
  const [border10, setBorder10] = useState(
    `1px solid ${branding?.accentColor}`,
  );

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const width = useWindowWidth();

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  if (!nav) window.location.reload();
  return (
    <BoxContainer withBorder>
      <div className={css.formWrapper}>
        <div className={css.subWrapper}>
          <h5 className={css.wrapperLabel}>Personal Information</h5>

          <div
            style={{
              boxShadow: `0vw 3px 3px ${branding?.accentColor?.replace(
                /[\d.]+\)$/g,
                '0.25)',
              )}`,
            }}
            className={css.textFieldSub2}
          >
            <div className={css.fullWidthFieldContainer}>
              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabelFullWidth}>First Name</p>
                <input
                  type="text"
                  placeholder=" "
                  id="firstName"
                  name="firstName"
                  ref={register({ required: true, maxLength: 30 })}
                  className={css.textFieldSmall}
                  onFocus={() =>
                    setBorder1(`2px solid ${branding?.accentColor}`)
                  }
                  onBlur={() =>
                    setBorder1(`1px solid ${branding?.accentColor}`)
                  }
                  style={{ border: border1, outline: 'none' }}
                />
                {errors.firstName && errors.firstName.type === 'required' && (
                  <ErrorMessageInput>This is required</ErrorMessageInput>
                )}
                {errors.firstName && errors.firstName.type === 'maxLength' && (
                  <ErrorMessageInput>Max length exceeded</ErrorMessageInput>
                )}
              </div>
            </div>
            <div className={css.fullWidthFieldContainer}>
              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabelFullWidth}>Middle Name or Initial</p>
                <input
                  type="text"
                  placeholder=" "
                  id="middleName"
                  name="middleName"
                  ref={register({ required: false, maxLength: 30 })}
                  className={css.textFieldSmall}
                  onFocus={() =>
                    setBorder2(`2px solid ${branding?.accentColor}`)
                  }
                  onBlur={() =>
                    setBorder2(`1px solid ${branding?.accentColor}`)
                  }
                  style={{ border: border2, outline: 'none' }}
                />

                {errors.firstName && errors.firstName.type === 'maxLength' && (
                  <ErrorMessageInput>Max length exceeded</ErrorMessageInput>
                )}
              </div>
            </div>
            <div className={css.fullWidthFieldContainer}>
              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabelFullWidth}>Last Name</p>
                <input
                  type="text"
                  placeholder=" "
                  id="lastName"
                  name="lastName"
                  ref={register({ required: true, maxLength: 30 })}
                  className={css.textFieldSmall}
                  onFocus={() =>
                    setBorder3(`2px solid ${branding?.accentColor}`)
                  }
                  onBlur={() =>
                    setBorder3(`1px solid ${branding?.accentColor}`)
                  }
                  style={{ border: border3, outline: 'none' }}
                />
                {errors.firstName && errors.firstName.type === 'required' && (
                  <ErrorMessageInput>This is required</ErrorMessageInput>
                )}
                {errors.firstName && errors.firstName.type === 'maxLength' && (
                  <ErrorMessageInput>Max length exceeded</ErrorMessageInput>
                )}
              </div>
            </div>
            <div className={css.fullWidthFieldContainer}>
              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabelFullWidth}>
                  {width <= 1024
                    ? 'SSN (last 4 digits)'
                    : 'Last 4 Digits of Social Security Number'}
                </p>
                <div className={css.inputIconWrapperFullWidth}>
                  <input
                    type={isPasswordVisible ? 'text' : 'password'}
                    placeholder=" "
                    id="ssn"
                    name="ssn"
                    maxLength={4}
                    ref={register({ required: false, validate: validSSN })}
                    className={css.textFieldSmall}
                    onFocus={() =>
                      setBorder4(`2px solid ${branding?.accentColor}`)
                    }
                    onBlur={() =>
                      setBorder4(`1px solid ${branding?.accentColor}`)
                    }
                    style={{ border: border4, outline: 'none' }}
                  />
                  <span onClick={togglePasswordVisibility}>
                    {isPasswordVisible ? (
                      <AiFillEye className={css.togglePasswordIcon} />
                    ) : (
                      <AiFillEyeInvisible className={css.togglePasswordIcon} />
                    )}
                  </span>
                </div>
                {errors.firstName && errors.firstName.type === 'required' && (
                  <ErrorMessageInput>This is required</ErrorMessageInput>
                )}
                {errors.firstName && errors.firstName.type === 'maxLength' && (
                  <ErrorMessageInput>Max length exceeded</ErrorMessageInput>
                )}
              </div>
            </div>
            <div className={css.fullWidthFieldContainer}>
              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabelFullWidth}>Date of Birth</p>
                <input
                  type="date"
                  id="dateOfBirth"
                  name="dateOfBirth"
                  placeholder="yyyy-mm-dd"
                  ref={register({ required: false, validate: validAge })}
                  className={css.textFieldSmall}
                  onFocus={() =>
                    setBorder5(`2px solid ${branding?.accentColor}`)
                  }
                  onBlur={() =>
                    setBorder5(`1px solid ${branding?.accentColor}`)
                  }
                  style={{
                    border: border5,
                    outline: 'none',
                    paddingRight: '20px',
                  }}
                />
              </div>
            </div>
            <div className={css.fullWidthFieldContainer}>
              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabelFullWidth}>Email</p>
                <input
                  type="email"
                  placeholder=" "
                  id="email"
                  name="email"
                  ref={register({ maxLength: 50 })}
                  className={css.textFieldSmall}
                  onFocus={() =>
                    setBorder6(`2px solid ${branding?.accentColor}`)
                  }
                  onBlur={() =>
                    setBorder6(`1px solid ${branding?.accentColor}`)
                  }
                  style={{ border: border6, outline: 'none' }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={css.subWrapper}>
          <h5 className={css.wrapperLabel}>
            Address Associated with Bank Account
          </h5>

          <div
            style={{
              boxShadow: `0vw 3px 3px ${branding?.accentColor?.replace(
                /[\d.]+\)$/g,
                '0.25)',
              )}`,
            }}
            className={css.textFieldSub2}
          >
            <div className={css.fullWidthFieldContainer}>
              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabelFullWidth}>Street Address</p>
                <input
                  type="text"
                  name="address1"
                  placeholder="Street Address"
                  className={css.textFieldSmall}
                  autoComplete="no"
                  ref={register({ required: false })}
                  onFocus={() =>
                    setBorder7(`2px solid ${branding?.accentColor}`)
                  }
                  onBlur={() =>
                    setBorder7(`1px solid ${branding?.accentColor}`)
                  }
                  style={{ border: border7, outline: 'none' }}
                />
              </div>
            </div>

            <div className={css.fullWidthFieldContainer}>
              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabelFullWidth}>Unit # / Apt #</p>
                <input
                  type="text"
                  name="address2"
                  placeholder="Unit # / Apt #"
                  className={css.textFieldSmall}
                  autoComplete="no"
                  ref={register({ required: false })}
                  onFocus={() =>
                    setBorder8(`2px solid ${branding?.accentColor}`)
                  }
                  onBlur={() =>
                    setBorder8(`1px solid ${branding?.accentColor}`)
                  }
                  style={{ border: border8, outline: 'none' }}
                />
              </div>
            </div>

            <div className={css.fullWidthFieldContainer}>
              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabelFullWidth}>City</p>
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  className={css.textFieldSmall}
                  autoComplete="no"
                  ref={register({ required: false })}
                  onFocus={() =>
                    setBorder9(`2px solid ${branding?.accentColor}`)
                  }
                  onBlur={() =>
                    setBorder9(`1px solid ${branding?.accentColor}`)
                  }
                  style={{ border: border9, outline: 'none' }}
                />
              </div>
            </div>

            <div className={css.fullWidthFieldContainer}>
              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabelFullWidth}>State</p>
                <select
                  className={css.textFieldSmall}
                  id="state"
                  name="state"
                  onFocus={() =>
                    setBorder10(`2px solid ${branding?.accentColor}`)
                  }
                  onBlur={() =>
                    setBorder10(`1px solid ${branding?.accentColor}`)
                  }
                  style={{ border: border10, outline: 'none' }}
                  ref={register({ required: false })}
                >
                  {states.map((item) => {
                    return (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className={css.fullWidthFieldContainer}>
              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabelFullWidth}>Zip Code</p>
                <input
                  type="text"
                  name="zipcode"
                  placeholder="Zip Code"
                  className={css.textFieldSmall}
                  autoComplete="no"
                  ref={register({ required: false })}
                  onFocus={() =>
                    setBorder1(`2px solid ${branding?.accentColor}`)
                  }
                  onBlur={() =>
                    setBorder1(`1px solid ${branding?.accentColor}`)
                  }
                  style={{ border: border1, outline: 'none' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </BoxContainer>
  );
};

const PersonalInformation = ({
  register,
  watch,
  setValue,
  control,
  errors,
  client,
  branding,
}) => (
  <div className="create-account__information-container">
    <FieldsPersonalInformation
      register={register}
      errors={errors}
      control={control}
      setValue={setValue}
      watch={watch}
      client={client}
      branding={branding}
    />
  </div>
);

const FieldsContactInformation = ({ setValue, watch, branding, register }) => {
  const [border5, setBorder5] = useState(`1px solid ${branding?.accentColor}`);

  const phoneNumber = watch('mobilePhone', '');
  console.log(phoneNumber);
  useEffect(() => {
    if (phoneNumber) {
      setValue('mobilePhone', formatAsPhoneNumber(phoneNumber));
    }
  }, [phoneNumber]);

  const formatAsPhoneNumber = (input) => {
    // Remove non-digit characters
    let numericInput = input.replace(/\D/g, '');

    // Check for and remove "1" or "+1" prefix
    if (numericInput.startsWith('1')) {
      numericInput = numericInput.substring(1);
    }

    let formattedNumber = '';

    if (numericInput.length > 3) {
      const areaCode = numericInput.substring(0, 3);
      const prefix = numericInput.substring(3, 6);
      const lineNumber = numericInput.substring(6);
      formattedNumber = `(${areaCode}) ${prefix}-${lineNumber}`;
    } else {
      formattedNumber = numericInput;
    }

    return formattedNumber;
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Backspace') {
      const currentNumber = watch('mobilePhone');
      const numericInput = currentNumber.replace(/\D/g, '');
      if (numericInput.length > 0) {
        // Remove the last character from numericInput
        const updatedNumber = numericInput.slice(0, -1);

        // Format and set the updated number
        setValue('mobilePhone', formatAsPhoneNumber(updatedNumber));

        // Prevent the default behavior of the Backspace key
        e.preventDefault();
      }
    }
  };

  const handleInput = () => {
    if (formatAsPhoneNumber(phoneNumber).length <= 14) {
      setValue('mobilePhone', formatAsPhoneNumber(phoneNumber));
    }
  };

  const handleFocus = () => {
    setBorder5(`2px solid ${branding?.accentColor}`);
  };

  const handleBlur = () => {
    setBorder5(`1px solid ${branding?.accentColor}`);
  };

  return (
    <BoxContainer withBorder>
      <div className={css.formWrapper}>
        <div className={css.subWrapper}>
          <h5 className={css.wrapperLabel}>Contact Information</h5>

          <div
            style={{
              boxShadow: `0vw 3px 3px ${branding?.accentColor?.replace(
                /[\d.]+\)$/g,
                '0.25)',
              )}`,
            }}
            className={css.textFieldSub2}
          >
            <div className={css.fullWidthFieldContainer}>
              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabelFullWidth}>Mobile Number</p>
                <input
                  ref={
                    formatAsPhoneNumber(phoneNumber).length <= 14
                      ? register({ required: true, maxLength: 14 })
                      : null
                  }
                  className={css.textFieldSmall}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  onInput={handleInput}
                  onKeyDown={handleKeyDown}
                  style={{ border: border5, outline: 'none' }}
                  name="mobilePhone"
                  type="tel"
                  maxLength={14}
                  inputMode="tel"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </BoxContainer>
  );
};

const ContactInformation = ({
  watch,
  setValue,
  register,
  errors,
  control,
  branding,
}) => (
  <div className={css.contactInformationComponentWrapper}>
    <FieldsContactInformation
      branding={branding}
      register={register}
      errors={errors}
      control={control}
      watch={watch}
      setValue={setValue}
    />
  </div>
);

const Account = (props) => {
  const { user } = getClientStore();
  const { loadingSearch, client, refetch } = useClientByPhone(user.mobilePhone);
  const clientID = get(client, '_id');
  const { loading, updateClient } = useUpdateClient();
  const tenantIdentifier = split(window.location.hostname, '.')[0];
  const { loading: loadingTenant, tenant } = useAllTenants(tenantIdentifier);
  const tenantID = get(tenant, '_id');
  const { register, handleSubmit, watch, errors, setValue, control } = useForm({
    defaultValues: client,
  });
  const { sensitiveData, refetch: refetchSensitiveData } = useSensitiveData();
  const { SSN, DOB } = sensitiveData || {};
  const { isLoading } = useSelector((state) => state.utility);
  const dispatch = useDispatch();
  const width = useWindowWidth();
  const history = useHistory();

  useEffect(() => {
    if (width < 768) {
      dispatch(closeNavbar());
    }
  }, []);

  useEffect(() => {
    if (client && sensitiveData) {
      setValue([
        { firstName: client.firstName },
        { middleName: client.middleName },
        { lastName: client.lastName },
        { address1: client.address1 },
        { address2: client.address2 },
        { state: client.state },
        { city: client.city },
        { zipcode: client.zipcode },
        { mobilePhone: validateNumber(client.mobilePhone) },
        { email: client.email },
        { ssn: ssnCutter(decrypt(SSN)) },
        { dateOfBirth: decrypt(DOB) },
      ]);
    }
  }, [client, SSN, DOB]);
  const mobilePhone = watch('mobilePhone');

  const ssnCutter = (ssn) => {
    if (ssn.length > 4) {
      return ssn.slice(ssn?.length - 4);
    } else return ssn;
  };

  const validateNumber = (phone) => {
    return phone ? phone.slice(2, 12) : phone;
  };

  console.log(tenantID);

  const onSubmit = async (newUser) => {
    dispatch(setLoading());
    delete newUser.mobilePhone;
    const sensitiveData = {
      SSN: encrypt(newUser.ssn),
      DOB: encrypt(newUser.dateOfBirth),
    };
    //removing sensititve data from query
    const { ssn, dateOfBirth, ...rest } = newUser;

    try {
      await saveSensitiveData(clientID, tenantID, sensitiveData);

      const resp = await updateClient({
        variables: {
          id: client._id,
          client: { 
            ...rest,                   
            updatedAt_utc: getISODateString(),
            updatedAt_offset: "+00:00",
          },
        },
      });

      if (resp?.data?.updateOneClient?._id) {
        window.location.reload();
      }
    } catch (err) {
      console.log(err);
    }
  };

  if (loading || loadingSearch || loadingTenant || isLoading) {
    return <SpinnerLoader />;
  }

  return (
    <div className={css.wrapper}>
      <BoxContainer withDoubleBorder withTopLogo widest>
        <div className="create-account__line-container">
          <div className="create-account__title">
            {displayPageHeader(history?.location?.pathname)}
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <PersonalInformation
            register={register}
            errors={errors}
            control={control}
            setValue={setValue}
            watch={watch}
            client={client}
            branding={props.branding}
          />
          <ContactInformation
            branding={props.branding}
            register={register}
            errors={errors}
            control={control}
            watch={watch}
            setValue={setValue}
          />
          <div className="d-flex justify-content-center mt-5">
            <PaymintsButton
              htmlType="submit"
              className="create-account__button"
              noShadow
              type={BUTTON_TYPE.INVERSE_BLUE}
            >
              Save
            </PaymintsButton>
          </div>
        </form>
      </BoxContainer>
    </div>
  );
};

export default withRouter(Account);
